import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectOpenAiDescriptionForRule } from '../../../../reducers/documentation/documentationReducer';

export const useInitializeOpenAiDescriptionForRule = ({
  metadataId,
  crmOrgId,
  shouldDataBeCalled,
  getOpenAiDescriptionForRule,
}: {
  metadataId: string;
  crmOrgId: string;
  shouldDataBeCalled: boolean;
  getOpenAiDescriptionForRule: (args: { crmOrgId: string; metadataId: string }) => Promise<void>;
}) => {
  const openAiDescription = useSelector(selectOpenAiDescriptionForRule(metadataId ?? '', crmOrgId));

  useEffect(() => {
    if (!openAiDescription && metadataId && shouldDataBeCalled) {
      getOpenAiDescriptionForRule({
        crmOrgId,
        metadataId,
      });
    }
  }, [crmOrgId, openAiDescription, getOpenAiDescriptionForRule, shouldDataBeCalled, metadataId]);
};
